import React from 'react';

const Footer: React.FC = () => (
    <footer className="mt-20 py-6 bg-slate-900/80 backdrop-blur-xl border-t border-white/10 text-center z-10 relative w-full max-w-full">
        <p className="text-xs sm:text-sm text-slate-400">
            © 2025 Tüm hakları saklıdır.
        </p>
        <p className="text-[10px] sm:text-xs text-slate-500 mt-1 sm:mt-2">
            Vizyon 2035, Fenerbahçe'nin geleceğe yönelik stratejik planıdır.
        </p>
    </footer>
);

export default Footer; 